import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Button } from 'antd';
import { configContainerVisibilitySelector, errorConfigSelector } from '@src/store/errorLogicConfig/configContainer/selectors';
import { changeConfigContainerVisibility, createConfig, updateConfig } from '@store/errorLogicConfig/configContainer/actions';
import { ConfigContainerWrapper } from '../styled';

import ConfigForm from './ConfigForm';
import { validateConfig } from './utils';

const ConfigContainer = () => {
  const dispatch = useDispatch();
  const isVisible = useSelector(configContainerVisibilitySelector);
  const config = useSelector(errorConfigSelector);

  const [hasErrors, setHasErrors] = useState(false);
  useEffect(() => {
    setHasErrors(false);
  }, [isVisible]);

  const onSave = (e) => {
    if (validateConfig(config)) {
      setHasErrors(false);
      // save/update
      if (config.id !== 0) {
        dispatch(updateConfig(config, 'Edit'));
      } else {
        dispatch(createConfig({}));
      }
      dispatch(changeConfigContainerVisibility(false));
    } else {
      setHasErrors(true);
    }
  };

  const onCancel = (e) => {
    dispatch(changeConfigContainerVisibility(false));
  };

  const footerButtons = [
    <Button key="discard" onClick={onCancel}>Discard</Button>,
    <Button key="save" type='primary' onClick={onSave}>Save</Button>,
  ];
  return (
    <ConfigContainerWrapper>
      <Modal
        title="Business Error Configuration"
        width="650px"
        open={isVisible}
        onCancel={onCancel}
        footer={footerButtons}
      >
        <ConfigForm hasErrors={hasErrors} />
      </Modal>
    </ConfigContainerWrapper>
  );
};

export default ConfigContainer;
